// extracted by mini-css-extract-plugin
export default {"particles":"ParticlesBackground_particles__pVA19","particle":"ParticlesBackground_particle__T04Jn","particleFloat":"ParticlesBackground_particleFloat__809zV"};